module.exports = __webpack_public_path__ + "img/podcast.b1a6f379.png";